(function () {
  'use strict';
  window.AlAmeerInitiativesData = Object.freeze({
    version: 1,
    house: Object.freeze({ id: 'house', name: 'London', lat: 51.5074, lng: -0.1278 }),
    countries: Object.freeze([
      Object.freeze({ id: 'yemen', name: 'Yemen', lat: 15.5527, lng: 48.5164, index: 1 }),
      Object.freeze({ id: 'gaza', name: 'Gaza', lat: 31.4167, lng: 34.3333, index: 2 }),
      Object.freeze({ id: 'sudan', name: 'Sudan', lat: 12.8628, lng: 30.2176, index: 3 })
    ])
  });
})();
